import axios from "axios";
import { EstimationsResponse, FetchEstimatedDataQuery } from "./types";

export const fetchEstimatedData = (
  payload: FetchEstimatedDataQuery
): Promise<EstimationsResponse> =>
  axios
    .post("/api/v1/dashboard/query/estimations", payload)
    .then((response) => response.data);
